import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Option } from "../../../types/General/Option";

interface UserSelectComponent {
  fieldNameObject: string;
  options: Option[];
  fieldName: string;
  width: string;
  control: any;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  isDisabled?: boolean;
  isLoaded: boolean;
}

export const userSelectFilterData = (
  roleOptions: Option[],
  organizationOptions: Option[],
  provinceOptions: Option[],
  countyOptions: Option[],
  activeOptions: Option[],
  control: any,
  setFilter: (filterName: string, value?: string) => void,
  setSelectedRole: Dispatch<SetStateAction<string | null>>,
  setSelectedOrganization: Dispatch<SetStateAction<string | null>>,
  setSelectedProvince: Dispatch<SetStateAction<Option | null>>,
  setSelectedCounty: Dispatch<SetStateAction<string | null>>,
  setSelectedActive: Dispatch<SetStateAction<string | null>>,
  selectedProvince: Option | null,
  provinceLoaded: boolean,
  countyLoaded: boolean,
  roleLoaded: boolean,
  organizationLoaded: boolean,
): UserSelectComponent[] => {
  const handleRoleChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedRoleId = e.target.value;
    setSelectedRole(e.target.selectedOptions[0].text);
    setFilter("RoleId", selectedRoleId);
  };

  const handleOrganizationChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedOrganizationId = e.target.value;
    setSelectedOrganization(e.target.selectedOptions[0].text);
    setFilter("OrganizationId", selectedOrganizationId);
  };

  const handleProvinceChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedProvinceId = e.target.value;
    const selected = provinceOptions.find(
      (p) => p.id.toString() === selectedProvinceId,
    );
    setSelectedProvince(selected || null);
    setFilter("ProvinceId", selectedProvinceId);
  };

  const handleCountyChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedCountyId = e.target.value;
    setSelectedCounty(e.target.selectedOptions[0].text);
    setFilter("CountyId", selectedCountyId);
  };

  const handleActiveChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const selectedActiveId = e.target.value;
    setSelectedActive(e.target.selectedOptions[0].text);
    setFilter("IsActive", selectedActiveId);
  };

  return [
    {
      fieldNameObject: "RoleId",
      options: roleOptions,
      fieldName: "Perfil",
      width: "230px",
      control: control,
      onChange: handleRoleChange,
      isLoaded: roleLoaded,
    },
    {
      fieldNameObject: "OrganizationId",
      options: organizationOptions,
      fieldName: "Entidade",
      width: "230px",
      control: control,
      onChange: handleOrganizationChange,
      isLoaded: organizationLoaded,
    },
    {
      fieldNameObject: "ProvinceId",
      options: provinceOptions,
      fieldName: "Província",
      width: "230px",
      control: control,
      onChange: handleProvinceChange,
      isLoaded: provinceLoaded,
    },
    {
      fieldNameObject: "CountyId",
      options: countyOptions,
      fieldName: "Município",
      width: "230px",
      control: control,
      onChange: handleCountyChange,
      isDisabled: !selectedProvince || selectedProvince.name === "",
      isLoaded: countyLoaded,
    },
    {
      fieldNameObject: "IsActive",
      options: activeOptions,
      fieldName: "Estado",
      width: "230px",
      control: control,
      onChange: handleActiveChange,
      isLoaded: true,
    },
  ];
};
